module.exports = __webpack_public_path__ + "static/media/planet_s_top.2162d76a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/planet_s_top.jpg
// module id = 2459
// module chunks = 0